import React, { useState, useEffect } from "react";
import api from "../api";

// Prontuarios do dia, em duas colunas.
// A esquerda quem sera atendida hoje; a direita a paciente escolhida, com o
// resumo clinico fixo, o historico e o editor lado a lado. A profissional
// escreve olhando o que foi feito da ultima vez - que e como ela trabalha.
export default function Prontuarios() {
  // a data de hoje no fuso de quem esta olhando, nao no fuso do servidor
  const localISO = (d) => { const x = new Date(d); x.setMinutes(x.getMinutes() - x.getTimezoneOffset()); return x.toISOString().slice(0, 10); };
  const hojeISO = localISO(new Date());
  const [dia, setDia]               = useState(hojeISO);
  const [lista, setLista]           = useState([]);
  const [carregando, setCarregando] = useState(true);
  const [erro, setErro]             = useState("");

  const [sel, setSel]               = useState(null);   // atendimento escolhido
  const [pront, setPront]           = useState(null);   // prontuario da paciente
  const [carregandoP, setCarregandoP] = useState(false);

  const [form, setForm]             = useState({ procedimento: "", texto: "" });
  const [salvando, setSalvando]     = useState(false);
  const [adendoDe, setAdendoDe]     = useState(null);
  const [textoAdendo, setTextoAdendo] = useState("");
  const [busca, setBusca]           = useState("");

  const corpo = (r) => (r && r.data !== undefined ? r.data : r);
  const recadoDe = (e) => (e && e.response && e.response.data && e.response.data.erro) || "Não consegui completar.";
  const hora = (v) => (v ? new Date(v).toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" }) : "--:--");
  const dt   = (v) => (v ? new Date(v).toLocaleDateString("pt-BR") : "—");
  const dth  = (v) => (v ? new Date(v).toLocaleString("pt-BR", { dateStyle: "short", timeStyle: "short" }) : "—");

  const carregarDia = async (d) => {
    setCarregando(true); setErro(""); setSel(null); setPront(null);
    try {
      const r = corpo(await api.get(`/prontuario/dia?data=${d}`));
      setLista((r && r.atendimentos) || []);
      if (r && r.aviso) setErro(r.aviso);
    } catch (e) { setErro(recadoDe(e)); }
    setCarregando(false);
  };
  useEffect(() => { carregarDia(dia); }, [dia]); // eslint-disable-line

  const abrir = async (a) => {
    setSel(a);
    setForm({ procedimento: a.procedimento || "", texto: "" });
    setAdendoDe(null); setBusca(""); setPront(null);
    if (!a.clienteId) return;
    setCarregandoP(true);
    try { setPront(corpo(await api.get(`/prontuario/paciente/${a.clienteId}`))); }
    catch (e) { setErro(recadoDe(e)); }
    setCarregandoP(false);
  };

  const recarregarPaciente = async () => {
    if (!sel || !sel.clienteId) return;
    try { setPront(corpo(await api.get(`/prontuario/paciente/${sel.clienteId}`))); } catch (e) { /* ignora */ }
  };

  const salvarEvolucao = async () => {
    if (salvando || !sel || !sel.clienteId) return;
    setSalvando(true); setErro("");
    try {
      await api.post("/prontuario/evolucao", {
        pacienteId: sel.clienteId, pacienteNome: sel.pacienteNome,
        texto: form.texto, procedimento: form.procedimento || sel.procedimento,
        dataAtendimento: new Date(dia + "T12:00:00").toISOString(), agendamentoId: sel._id, profissionalNome: sel.profissionalNome,
      });
      setForm({ procedimento: sel.procedimento || "", texto: "" });
      await recarregarPaciente();
      // atualiza o marcador da linha sem recarregar o dia inteiro
      setLista((l) => l.map((x) => (x._id === sel._id ? { ...x, temEvolucao: true } : x)));
    } catch (e) { setErro(recadoDe(e)); }
    setSalvando(false);
  };

  const salvarAdendo = async (registro) => {
    if (salvando) return;
    setSalvando(true);
    try {
      await api.post(`/prontuario/${registro._id}/adendo`, { texto: textoAdendo });
      setAdendoDe(null); setTextoAdendo("");
      await recarregarPaciente();
    } catch (e) { setErro(recadoDe(e)); }
    setSalvando(false);
  };

  const mudarDia = (passos) => {
    const d = new Date(dia + "T12:00:00");
    d.setDate(d.getDate() + passos);
    setDia(localISO(d));
  };

  const faltam = lista.filter((a) => !a.temEvolucao && a.status !== "desmarcado").length;

  const campo  = { width:"100%", padding:"9px 11px", borderRadius:8, border:"1px solid var(--border-color)", background:"var(--card-bg)", color:"var(--text-primary)", fontSize:13, fontFamily:"inherit", boxSizing:"border-box" };
  const botao  = { background:"#EE6A1A", border:"none", borderRadius:8, padding:"9px 16px", color:"#fff", cursor:"pointer", fontWeight:700, fontSize:13 };
  const botao2 = { background:"transparent", border:"1px solid var(--border-color)", borderRadius:8, padding:"6px 12px", color:"var(--text-secondary)", cursor:"pointer", fontWeight:600, fontSize:12 };
  const seta   = { background:"var(--hover-bg)", border:"1px solid var(--border-color)", borderRadius:8, width:32, height:32, cursor:"pointer", color:"var(--text-secondary)", fontSize:15 };
  const bloco  = { background:"var(--card-bg)", border:"1px solid var(--border-color)", borderRadius:12, padding:14 };
  const rotulo = { fontSize:10.5, color:"var(--text-secondary)", fontWeight:700, letterSpacing:".03em", marginBottom:5 };

  const anamnese = pront && pront.anamnese;
  const resp = (id) => (anamnese && anamnese.dados ? anamnese.dados[id] : "");
  const alertas = (anamnese && anamnese.dados && anamnese.dados.__alertas) || [];

  const evolucoes = ((pront && pront.evolucoes) || []).filter((e) => {
    if (!busca.trim()) return true;
    const t = (e.texto || "") + " " + (e.procedimento || "");
    return t.toLowerCase().indexOf(busca.trim().toLowerCase()) !== -1;
  });

  return (
    <div style={{ padding:"18px 20px" }}>
      <div style={{ fontSize:24, fontWeight:800, color:"var(--text-primary)" }}>Prontuários</div>
      <div style={{ fontSize:13, color:"var(--text-secondary)", marginBottom:16 }}>
        Os atendimentos do dia e o que ainda falta registrar
      </div>

      <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:16, flexWrap:"wrap" }}>
        <button style={seta} onClick={()=>mudarDia(-1)}>‹</button>
        <input type="date" value={dia} onChange={(e)=>setDia(e.target.value)} style={{ ...campo, width:165 }}/>
        <button style={seta} onClick={()=>mudarDia(1)}>›</button>
        <button style={botao2} onClick={()=>setDia(hojeISO)}>Hoje</button>
        {!carregando && (
          <span style={{ fontSize:13, color: faltam ? "#B44A0A" : "#0a7a55", fontWeight:700, marginLeft:4 }}>
            {faltam ? `${faltam} sem evolução escrita` : "tudo registrado"}
          </span>
        )}
      </div>

      {erro && (
        <div style={{ background:"#FDE7DA", borderRadius:8, padding:"9px 13px", marginBottom:14, fontSize:12, color:"#B44A0A" }}>{erro}</div>
      )}

      <div style={{ display:"flex", gap:14, alignItems:"flex-start", flexWrap:"wrap" }}>

        {/* ------------------------------------------------ coluna do dia */}
        <div style={{ flex:"0 0 280px", minWidth:260 }}>
          {carregando && <div style={{ padding:"30px 0", textAlign:"center", color:"var(--text-muted)", fontSize:13 }}>Carregando...</div>}
          {!carregando && lista.length===0 && (
            <div style={{ ...bloco, textAlign:"center", color:"var(--text-muted)", fontSize:13 }}>Nenhum atendimento nesse dia.</div>
          )}
          {lista.map((a)=>{
            const ativo = sel && sel._id === a._id;
            return (
              <div key={a._id} onClick={()=>abrir(a)}
                style={{ background: ativo ? "#FDE7DA" : "var(--card-bg)",
                         border:"1px solid " + (ativo ? "#EE6A1A" : "var(--border-color)"),
                         borderRadius:10, padding:"9px 11px", marginBottom:8, cursor:"pointer" }}>
                <div style={{ display:"flex", justifyContent:"space-between", alignItems:"baseline", gap:8 }}>
                  <span style={{ fontSize:13, fontWeight:800, color: ativo ? "#B44A0A" : "var(--text-primary)" }}>{hora(a.hora)}</span>
                  <span style={{ fontSize:9.5, fontWeight:800, borderRadius:6, padding:"2px 6px", whiteSpace:"nowrap",
                                 background: a.temEvolucao ? "#E3F5EC" : "#FDE7DA",
                                 color:      a.temEvolucao ? "#0a7a55" : "#B44A0A" }}>
                    {a.temEvolucao ? "escrita" : "falta"}
                  </span>
                </div>
                <div style={{ fontSize:13, fontWeight:700, color: ativo ? "#B44A0A" : "var(--text-primary)", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap", marginTop:2 }}>
                  {a.pacienteNome}
                </div>
                <div style={{ fontSize:11, color:"var(--text-secondary)", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>
                  {a.procedimento || "—"}
                </div>
                {!a.clienteId && (
                  <div style={{ fontSize:10, color:"var(--text-muted)", marginTop:3 }}>sem cadastro de paciente</div>
                )}
              </div>
            );
          })}
        </div>

        {/* ------------------------------------------------ painel da paciente */}
        <div style={{ flex:"1 1 640px", minWidth:0 }}>
          {!sel && (
            <div style={{ ...bloco, padding:"50px 20px", textAlign:"center", color:"var(--text-muted)", fontSize:13 }}>
              Escolha um atendimento na lista ao lado.
            </div>
          )}

          {sel && !sel.clienteId && (
            <div style={{ ...bloco, padding:"30px 20px", textAlign:"center" }}>
              <div style={{ fontSize:14, fontWeight:700, color:"var(--text-primary)", marginBottom:6 }}>{sel.pacienteNome}</div>
              <div style={{ fontSize:13, color:"var(--text-secondary)" }}>
                Essa pessoa está na agenda mas não existe no cadastro de Pacientes,<br/>
                então não há prontuário onde guardar o registro.
              </div>
            </div>
          )}

          {sel && sel.clienteId && (
            <div>
              {/* cabecalho */}
              <div style={{ ...bloco, marginBottom:12, display:"flex", justifyContent:"space-between", alignItems:"center", gap:12, flexWrap:"wrap" }}>
                <div>
                  <div style={{ fontSize:17, fontWeight:800, color:"var(--text-primary)" }}>{sel.pacienteNome}</div>
                  <div style={{ fontSize:12, color:"var(--text-secondary)" }}>
                    {hora(sel.hora)} · {sel.procedimento || "sem procedimento"}{sel.profissionalNome ? " · " + sel.profissionalNome : ""}
                  </div>
                </div>
                <div style={{ fontSize:12, color:"var(--text-secondary)" }}>
                  {((pront && pront.evolucoes) || []).length} atendimento(s) no histórico
                </div>
              </div>

              {/* resumo clinico - o que precisa estar sempre a vista */}
              <div style={{ ...bloco, marginBottom:12,
                            borderColor: alertas.length ? "#EE6A1A" : "var(--border-color)",
                            background: alertas.length ? "#FDF0E6" : "var(--card-bg)" }}>
                <div style={{ ...rotulo, color: alertas.length ? "#B44A0A" : "var(--text-secondary)" }}>
                  {alertas.length ? "ATENÇÃO ANTES DE ATENDER" : "RESUMO CLÍNICO"}
                </div>
                {carregandoP && <div style={{ fontSize:12, color:"var(--text-muted)" }}>Carregando...</div>}
                {!carregandoP && !anamnese && (
                  <div style={{ fontSize:13, color:"var(--text-primary)" }}>
                    Anamnese ainda não preenchida. Faça pela ficha da paciente, em Pacientes.
                  </div>
                )}
                {!carregandoP && anamnese && (
                  <div>
                    {alertas.map((a,i)=>(
                      <div key={i} style={{ fontSize:13, color:"#7A3306", lineHeight:1.5 }}>• {a}</div>
                    ))}
                    <div style={{ display:"flex", gap:20, flexWrap:"wrap", marginTop: alertas.length ? 8 : 0 }}>
                      <div style={{ minWidth:180 }}>
                        <div style={rotulo}>ALERGIAS</div>
                        <div style={{ fontSize:12.5, color:"var(--text-primary)" }}>{resp("alergias") || "nenhuma relatada"}</div>
                      </div>
                      <div style={{ minWidth:180 }}>
                        <div style={rotulo}>MEDICAMENTOS EM USO</div>
                        <div style={{ fontSize:12.5, color:"var(--text-primary)" }}>{resp("medicamentos") || "nenhum relatado"}</div>
                      </div>
                      <div style={{ minWidth:140 }}>
                        <div style={rotulo}>ANAMNESE DE</div>
                        <div style={{ fontSize:12.5, color:"var(--text-primary)" }}>{dt(anamnese.createdAt)}</div>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {/* historico  |  editor */}
              <div style={{ display:"flex", gap:12, alignItems:"flex-start", flexWrap:"wrap" }}>

                <div style={{ flex:"1 1 320px", minWidth:0 }}>
                  <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:8 }}>
                    <span style={{ fontSize:13, fontWeight:800, color:"var(--text-primary)" }}>Histórico</span>
                    <input value={busca} onChange={(e)=>setBusca(e.target.value)} placeholder="buscar no prontuário..."
                      style={{ ...campo, padding:"6px 10px", fontSize:12, flex:1 }}/>
                  </div>
                  <div style={{ maxHeight:520, overflowY:"auto", paddingRight:4 }}>
                    {carregandoP && <div style={{ fontSize:12, color:"var(--text-muted)" }}>Carregando...</div>}
                    {!carregandoP && evolucoes.length===0 && (
                      <div style={{ ...bloco, textAlign:"center", color:"var(--text-muted)", fontSize:13 }}>
                        {busca ? "Nada encontrado." : "Nenhum atendimento registrado ainda."}
                      </div>
                    )}
                    {evolucoes.map((e)=>(
                      <div key={e._id} style={{ ...bloco, marginBottom:8 }}>
                        <div style={{ display:"flex", justifyContent:"space-between", gap:8, marginBottom:5 }}>
                          <span style={{ fontSize:12.5, fontWeight:800, color:"var(--text-primary)" }}>{e.procedimento || "Atendimento"}</span>
                          <span style={{ fontSize:11, color:"var(--text-muted)", whiteSpace:"nowrap" }}>{dt(e.dataAtendimento || e.createdAt)}</span>
                        </div>
                        <div style={{ fontSize:12.5, color:"var(--text-primary)", lineHeight:1.55, whiteSpace:"pre-wrap" }}>{e.texto}</div>
                        <div style={{ fontSize:10.5, color:"var(--text-muted)", marginTop:6 }}>
                          {e.nomeCriador || e.profissionalNome || "—"} · {dth(e.createdAt)}
                        </div>
                        {(e.adendos||[]).map((a)=>(
                          <div key={a._id} style={{ borderLeft:"2px solid #EE6A1A", paddingLeft:9, marginTop:7 }}>
                            <div style={{ fontSize:10.5, color:"var(--text-muted)" }}>Adendo · {dth(a.createdAt)} · {a.nomeCriador}</div>
                            <div style={{ fontSize:12.5, color:"var(--text-primary)", lineHeight:1.5, whiteSpace:"pre-wrap" }}>{a.texto}</div>
                          </div>
                        ))}
                        {adendoDe === e._id ? (
                          <div style={{ marginTop:8 }}>
                            <textarea rows={3} style={campo} value={textoAdendo}
                              placeholder="O que precisa ser acrescentado..."
                              onChange={(ev)=>setTextoAdendo(ev.target.value)}/>
                            <div style={{ display:"flex", gap:7, marginTop:7 }}>
                              <button style={botao} disabled={salvando} onClick={()=>salvarAdendo(e)}>
                                {salvando ? "..." : "Salvar adendo"}
                              </button>
                              <button style={botao2} onClick={()=>{ setAdendoDe(null); setTextoAdendo(""); }}>Cancelar</button>
                            </div>
                          </div>
                        ) : (
                          <button style={{ ...botao2, marginTop:7 }} onClick={()=>{ setAdendoDe(e._id); setTextoAdendo(""); }}>
                            + Adendo
                          </button>
                        )}
                      </div>
                    ))}
                  </div>
                </div>

                <div style={{ flex:"1 1 320px", minWidth:0 }}>
                  <div style={{ fontSize:13, fontWeight:800, color:"var(--text-primary)", marginBottom:8 }}>
                    Registrar este atendimento
                  </div>
                  <div style={bloco}>
                    <div style={rotulo}>PROCEDIMENTO</div>
                    <input style={campo} value={form.procedimento}
                      onChange={(e)=>setForm({ ...form, procedimento:e.target.value })}/>
                    <div style={{ ...rotulo, marginTop:11 }}>O QUE FOI FEITO E COMO A PACIENTE REAGIU</div>
                    <textarea rows={12} style={campo} value={form.texto}
                      placeholder="Produtos e parâmetros usados, região tratada, intercorrências, orientações dadas..."
                      onChange={(e)=>setForm({ ...form, texto:e.target.value })}/>
                    <div style={{ fontSize:10.5, color:"var(--text-muted)", margin:"8px 0" }}>
                      Depois de salvo este registro não pode mais ser alterado. Correções entram como adendo.
                    </div>
                    <button style={{ ...botao, opacity: form.texto.trim().length>=10 ? 1 : .5 }}
                      disabled={salvando || form.texto.trim().length<10}
                      onClick={salvarEvolucao}>{salvando ? "Salvando..." : "Salvar registro"}</button>
                  </div>
                </div>

              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
